import React, { PureComponent } from 'react';
import axios from 'axios';
import MetaTags from 'react-meta-tags';
import BackButton from '../components/BackButton.js';

export default class extends PureComponent {
    state = {
        content: null,
        acf: null
    }

    componentWillMount() {
        this.props.setWhiteLogo(false);
    }

    componentDidMount() {
        this.getContent();
    }

    async getContent() {
        const response = await axios.get(process.env.CMS_URL + `/wp-json/wp/v2/pages/${this.props.pageID}?acf_format=standard`);
        
        this.setState({
            content: response.data.content.rendered,
            acf: response.data.acf
        }, () => {
            this.animatePage();
        });
    }

    animatePage() {
        const textPage = document.getElementById('TextPage');
        setTimeout(() => {
            textPage.classList.add('__active');
        }, 100);
    }

    render() {
        const { content, acf } = this.state;
        const { backButton } = this.props;
        
        return (
            <div>
                <div className="text" id="TextPage">
                    { content && (
                        <div className="text-content">
                            <MetaTags>
                                <title>{acf.page_title}</title>
                                <meta property="og:title" content={acf.page_title} />
                                <meta name="description" content={acf.meta_description} />
                            </MetaTags>
                            <div className="container">
                                { backButton && <BackButton />}
                                <div className="usercontent" dangerouslySetInnerHTML={{__html: content }}/> 
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/TextPage/index.js